// extracted by mini-css-extract-plugin
module.exports = {"root":"Tab_root__4vSac","root--selected":"Tab_root--selected__FZnxH","rotation":"Tab_rotation__Qb1o0"};